module.exports = {
    // api_root: 'http://107.22.151.243',
    api_root: process.env.NODE_ENV == "production" ? "http://#{EnvironmentPrefix}carbuyapi.pullapart.com" : "http://localhost:3000",
    api_root_path_admin: "/api/v1/admin",
    api_root_path: "/api/v1",
    carbuyservice: process.env.NODE_ENV == "production" ? "https://#{EnvironmentPrefix}carbuyservice.pullapart.com" : "http://localhost:5000",
    miccServerBase: "https://ignite.pullapart.com",
    enterpriseservice: process.env.NODE_ENV == "production" ? "https://#{EnvironmentPrefix}enterpriseservice.pullapart.com" : "https://dev-enterpriseservice.pullapart.com",
    paq_auth_api_root: process.env.NODE_ENV == "production" ? "https://#{EnvironmentPrefix}auth-services.pullapart.com" : "https://dev-auth-services.pullapart.com",
    paq_api_root: process.env.NODE_ENV == "production" ? "https://#{EnvironmentPrefix}pricingcalc-services.pullapart.com" : "https://dev-pricingcalc-services.pullapart.com",
    inventory_root: process.env.NODE_ENV == "production" ? "https://#{EnvironmentPrefix}inventoryservice.pullapart.com" : "https://dev-inventoryservice.pullapart.com",
    paq_api_info: {
        Login: process.env.NODE_ENV == "production" ? "#{PAQApiLogin}" : "dcb1",
        Password: process.env.NODE_ENV == "production" ? "#{PAQApiPassword}" : "D1r3c+C4r",
        AppID: process.env.NODE_ENV == "production" ? "#{PAQApiAppId}" : "DCBPricingCalculator",
        AppAPILogin: process.env.NODE_ENV == "production" ? "#{PAQApiAppLogin}" : "DCB",
        AppAPIPassword: process.env.NODE_ENV == "production" ? "#{PAQApiAppPaswword}" : "DCBapi#2017"
    },
    zerobounce_api_key: process.env.NODE_ENV == "production" ? "#{ZerobounceAPIKey}" : "123557a1c5114af08fba3c36798781ec",
    syncUsersWithRemote: process.env.NODE_ENV == "production" ? "#{SyncUsersWithRemote}" : true,
    dcb_dispatch_url: process.env.NODE_ENV == "production" ? "https://#{EnvironmentPrefix}dcb.pullapart.com/Quote/ViewQuote?quoteId=" : "https://dev-dcb.pullapart.com/Quote/ViewQuote?quoteId=",
    use_mitel: process.env.NODE_ENV == "production" ? "#{UseMitel}" : "false",
    use_livevox: process.env.NODE_ENV == "production" ? "#{UseLivevox}" : "false",
    use_verint: process.env.NODE_ENV == "production" ? "#{UseVerint}" : "true",
    enable_clipboard_copy_on_outbound_dial: process.env.NODE_ENV == "production" ? "#{EnableClipboardCopyOnOutboundDial}" : "true",
    outbound_call_code_id: process.env.NODE_ENV == "production" ? "#{OutboundCallCodeID}" : "0",
    noDispatchMarkets: process.env.NODE_ENV == "production" ? "#{NoDispatch}" : "26, 27, 28, 29, 30, 31, 32, 33, 34, 35",
    manualDispatchLocations: process.env.NODE_ENV == "production" ? "#{ManualDispatch}" : "35",
    offerpage_comparablevalue: 100,
    thirdPartyPartner: process.env.NODE_ENV == "production" ? "#{ThirdPartyPartner}" : "Peddle"
}



// WEBPACK FOOTER //
// ./src/config.js